import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useFamilyRole } from '../hooks/useFamilyRole';

function AnimatedNavLink({ to, children, end, onNavigate }) {
  const location = useLocation();
  const isActive = end ? location.pathname === to : location.pathname.startsWith(to);
  const [isHovered, setIsHovered] = useState(false);

  // Handler for navigation with additional logic
  const handleClick = () => {
    if (onNavigate) {
      onNavigate(to);
    }
  };

  return (
    <NavLink
      to={to}
      className={isActive ? 'nav-link active' : 'nav-link'}
      end={end}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={handleClick}
      style={{
        transform: isHovered && !isActive ? 'translateY(-2px)' : (isActive ? 'translateY(-2px)' : 'translateY(0)'),
        transition: 'all 0.3s cubic-bezier(0.25, 0.1, 0.25, 1)'
      }}
    >
      {React.Children.map(children, child => {
        if (child.type === 'svg') {
          return React.cloneElement(child, {
            style: {
              transition: 'all 0.3s cubic-bezier(0.25, 0.1, 0.25, 1)',
              transform: isHovered || isActive ? 'scale(1.1)' : 'scale(1)'
            }
          });
        }
        if (child.type === 'span') {
          return React.cloneElement(child, {
            style: {
              color: isActive ? 'var(--primary-color)' : 'inherit',
              fontWeight: isActive ? '600' : 'inherit',
              transition: 'all 0.3s cubic-bezier(0.25, 0.1, 0.25, 1)'
            }
          });
        }
        return child;
      })}
    </NavLink>
  );
}

function Navigation() {
  const { canCreateEvents } = useFamilyRole();
  
  // Handle navigation events
  const handleNavigate = (path) => {
    // If navigating to calendar
    if (path === '/calendar') {
      // Check if authenticated
      const isAuthenticated = localStorage.getItem('googleAccessToken');
      if (isAuthenticated) {
        console.log('Calendar navigation - authenticated user');
      }
    }
  };
  

  return (
    <nav className="app-navigation">
      <AnimatedNavLink to="/" end onNavigate={handleNavigate}>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
          <polyline points="9 22 9 12 15 12 15 22"></polyline>
        </svg>
        <span>New</span>
      </AnimatedNavLink>
      <AnimatedNavLink to="/calendar" onNavigate={handleNavigate}>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
          <line x1="16" y1="2" x2="16" y2="6"></line>
          <line x1="8" y1="2" x2="8" y2="6"></line>
          <line x1="3" y1="10" x2="21" y2="10"></line>
        </svg>
        <span>Calendar</span>
      </AnimatedNavLink>
      {canCreateEvents && (
        <AnimatedNavLink to="/upload" onNavigate={handleNavigate}>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="12" y1="5" x2="12" y2="19"></line>
            <line x1="5" y1="12" x2="19" y2="12"></line>
          </svg>
          <span>Add</span>
        </AnimatedNavLink>
      )}
    </nav>
  );
}

export default Navigation;